// components/common/GlobalLoading.tsx
import React from 'react';
import { useLoadingStore } from '@/store/loadingStore';

const GlobalLoading = () => {
    const isLoading = useLoadingStore((state) => state.isLoading);
    const loadingText = useLoadingStore((state) => state.loadingText);

    if (!isLoading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '20px 40px',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
            }}>
                <div className="spinner" />
                <p>{loadingText}</p>
            </div>
        </div>
    );
};

export default GlobalLoading;